<template>
  <div class="account-list-container">
    <SubMenu
      class="pt-0 mt-0 pb-4 mb-4 d-flex justify-content-center account-list-container__submenu"
      :items="items"
      variant="horizontal"
    >
      <template slot-scope="{ item }">
        <router-link
          :to="{
            name: $route.name,
            params: { ...account.params, ...$route.params, tab: item.id },
          }"
        >
          <TextBlock
            :text="$t(item.key, item.labelActive || item.label, item.params)"
          />
        </router-link>
      </template>
    </SubMenu>
    <Panel v-if="currentComponent">
      <component :is="currentComponent" />
    </Panel>
    <div class="d-flex justify-content-center cta-navigation-button-wrapper">
      <router-link
        :to="{
          name: backRouteName,
          params: { ...account.params, ...$route.params },
        }"
      >
        <HeraFormBtn
          class="btn btn-secondary"
          variant="full-width"
          :label="$t('_web_tournament_back', 'Back')"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SubMenu from '@/components/common/SubMenu';
import TextBlock from '@/components/atoms/TextBlock';
import Panel from '@/components/atoms/Panel';
import HeraFormBtn from '@/components/atoms/HeraFormBtn';
import ROUTER_NAMES_ACCOUNT from '@/constants/router/account';

const Followers = () => import('./Followers');
const Following = () => import('./Following');
const Friends = () => import('./Friends');
const Requests = () => import('./FriendRequests');

export default {
  name: 'ManageProfile',
  components: {
    SubMenu,
    TextBlock,
    Panel,
    HeraFormBtn,
  },
  computed: {
    ...mapState('current', ['account']),
    backRouteName() {
      return ROUTER_NAMES_ACCOUNT.ACCOUNT;
    },
    currentTab() {
      return this.$route.params.tab;
    },
    currentComponent() {
      return (
        this.items.filter(i => i.id === this.currentTab)[0].component || null
      );
    },
    items() {
      const { countsStrings } = this.account;

      const tabs = [
        {
          id: 'followers',
          label: 'Followers',
          labelActive: 'Followers ({followers})',
          key: '_web_profile-manage_followers-tab',
          component: Followers,
          params: countsStrings,
          active: this.currentTab === 'followers',
        },
        {
          id: 'followings',
          label: 'Followings',
          labelActive: 'Followings ({followings})',
          key: '_web_profile-manage_following-tab',
          component: Following,
          params: countsStrings,
          active: this.currentTab === 'followings',
        },
        {
          id: 'friends',
          label: 'Friends',
          labelActive: 'Friends ({friends})',
          key: '_web_profile-manage_friends-tab',
          component: Friends,
          params: countsStrings,
          active: this.currentTab === 'friends',
        },
      ];

      if (this.account._canEdit) {
        tabs.push({
          id: 'requests',
          label: 'Requests',
          key: '_web_profile-manage_friend-requests-tab',
          component: Requests,
          active: this.currentTab === 'requests',
        });
      }
      return tabs;
    },
  },
};
</script>

<style lang="scss">
.account-list-container__submenu {
  background-color: $ph-bg;
}

@media (max-width: 767px) {
  .account-list-container__submenu {
    gap: 6px;
    flex-direction: column !important;
    .list-group__item-expander {
      flex: 0 0 0px !important;
    }
    li {
      flex-grow: 1;
      min-width: unset !important;

      a {
        padding: 10px 3px !important;
        height: 100%;
      }
    }
  }
}
</style>
